import { useContext } from 'react';
import { OnlineStatusContext } from '../services';

export const useOnlineStatus = () => useContext(OnlineStatusContext);
